<template>
  <el-dialog
    :title="$t('mainCategoryProduct.edit')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('mainCategoryProduct.startTime')" prop="startTime">
        <el-date-picker
          v-model="form.startTime"
          type="datetime"
          :placeholder="$t('mainCategoryProduct.selectStartTime')"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.endTime')" prop="endTime">
        <el-date-picker
          v-model="form.endTime"
          type="datetime"
          :placeholder="$t('mainCategoryProduct.selectEndTime')"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width:100%">
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('mainCategoryProduct.sort')" prop="seq">
        <el-input 
          v-model="form.seq" 
          :placeholder="$t('mainCategoryProduct.inputSort')">
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
      <el-button type="primary" @click="submitForm">{{$t('common.save')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMainCategoryProduct } from '@/api/admin/mainCategoryProduct/mainCategoryProductApi'

export default {
  name: 'EditMainCategoryProduct',
  data() {
    return {
      dialogVisible: false,
      form: {
        mcProductId: '',
        startTime: '',
        endTime: '',
        seq: ''
      },
      rules: {
        startTime: [
          { required: true, message: this.$t('mainCategoryProduct.startTimeRequired'), trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: this.$t('mainCategoryProduct.endTimeRequired'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('mainCategoryProduct.sortRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('mainCategoryProduct.sortMustNumber'), trigger: 'blur' }
        ],
        mcProductId: [
          { required: true, message: this.$t('mainCategoryProduct.idRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.form = Object.assign({}, data)
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateMainCategoryProduct(this.form)
            this.$message.success(this.$t('mainCategoryProduct.editSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            console.error('修改失败:', error)
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>